import { useQueryClient } from "@tanstack/react-query";
import { useCallback } from "react";
import {
  CardsListItem,
  ListCardsResponseWithProjectName,
} from "tng-address-collection-shared/types/apiTypes.ts";
import { resolveEmployeeName } from "./getSenderSignature.ts";
import { queryKeys } from "./queryKeys.ts";

export const useToggleOtherCardSignatureCache = (projectId: string) => {
  const queryClient = useQueryClient();

  return useCallback(
    (cardId: string, uidNumber: number, action: "add" | "remove") => {
      queryClient.setQueryData<ListCardsResponseWithProjectName>(
        queryKeys.cardsInProject(projectId),
        (old) => {
          const oldCard = old?.items.find((card) => card.id === cardId);
          if (!oldCard?.signatures) {
            return old;
          }
          const signaturesWithoutUidNumber = oldCard?.signatures.filter(
            (x) => x.uidNumber !== uidNumber,
          );
          const newSignatures =
            action === "remove"
              ? signaturesWithoutUidNumber
              : signaturesWithoutUidNumber?.concat({
                  uidNumber,
                  name: resolveEmployeeName(queryClient, uidNumber),
                });
          const tempCard: CardsListItem = {
            ...oldCard,
            signatures: newSignatures,
            numberOfSignatures: newSignatures.length,
          };
          const updatedResponse: ListCardsResponseWithProjectName = {
            projectDisplayName: old?.projectDisplayName || "",
            items: [
              ...(old?.items.filter((card) => card.id !== cardId) || []),
              tempCard,
            ],
            hiddenFields: old?.hiddenFields || [],
            projectShepherds: old?.projectShepherds || {
              groups: [],
              individuals: [],
            },
            projectInfoBox: old?.projectInfoBox,
            hasPermissions: old?.hasPermissions ?? true,
          };
          return updatedResponse;
        },
      );
    },
    [queryClient, projectId],
  );
};
